import { render, staticRenderFns } from "./MeetingSync.vue?vue&type=template&id=64b9df7c&scoped=true&"
import script from "./MeetingSync.vue?vue&type=script&lang=js&"
export * from "./MeetingSync.vue?vue&type=script&lang=js&"
import style0 from "./MeetingSync.vue?vue&type=style&index=0&id=64b9df7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b9df7c",
  null
  
)

export default component.exports